import { AppRoutes } from "../app-routes"
import { readLocalStorage, removeFromLocalStorage } from "./guarded-local-storage"

export const REDIRECT_TARGET_KEY = "redirectTarget"

export const navigateToFirstRemainingProduct = (navigate: (route: string) => void): boolean => {
  const currentPath = window.location.pathname
  const knownRoutes: string[] = Object.values(AppRoutes)
  const storedTarget = readLocalStorage(REDIRECT_TARGET_KEY)

  const isValidRoute = knownRoutes.includes(currentPath)

  if (!isValidRoute) {
    removeFromLocalStorage(REDIRECT_TARGET_KEY)
    return false
  }

  if (storedTarget && storedTarget !== currentPath) {
    navigate(storedTarget)
    return true
  }

  return false
}
